const RegExpr = {
  /**
   * 校验手机号
   * @param mobile
   * @returns {boolean}
   */
  checkMobile: mobile => {
    return /^[1][0-9]{10}$|^09\d{8}$/.test(mobile)
  },

  /**
   * 校验纯数字
   * @param num
   * @returns {boolean}
   */
  checkNum: num => {
    return /^[0-9]+$/.test(num)
  },

  /**
   * 校验用户名：1-20位字符，首字符为字母
   * @param str
   * @returns {RegExp}
   */
  checkUserName: str => {
    return /^[a-zA-Z]{1,20}$/.test(str)
  },

  /**
   * 校验密码：6-20位，数字、字母、下划线
   * @param str
   * @returns {boolean}
   */
  checkPwd: str => {
    return /^(\\w){6,20}$/.test(str)
  },

  /**
   * 校验正整数 + 0
   * @param num
   * @returns {boolean}
   */
  checkPositiveInteger: num => {
    return /^[0-9]*[1-9][0-9]*$/.test(num)
  },

  /**
   * 校验字符串是否为数字
   * @param str
   * @returns {boolean}
   */
  isNumber: str => {
    var regPos = /^\d+(\.\d+)?$/ // 非负浮点数
    var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/ // 负浮点数
    if (regPos.test(str) || regNeg.test(str)) {
      return true
    } else {
      return false
    }
  },
  /**
   * 校验邮箱号（宽松模式，支持多种邮箱格式）
   * @param email
   * @returns {boolean}
   */
  isEmail: email => {
    // eslint-disable-next-line
    // 宽松的邮箱校验：支持字母、数字、点、下划线、连字符、加号
    // 支持多级域名（如 sub.domain.co.uk）
    // 顶级域名支持2个以上字母（包含新顶级域名如 .info, .travel, .technology 等）
    var regEmail = /^[a-zA-Z0-9][a-zA-Z0-9._+-]*@([a-zA-Z0-9][a-zA-Z0-9.-]*\.)+[a-zA-Z]{2,}$/
    return regEmail.test(email)
  },
  /**
   * 校验身份证号码
   */
  isIdCard: idCard => {
    const reg = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
    if (reg.test(idCard)) {
      return true
    } else {
      return false
    }
  },
  /**
   * @param {Array} arg
   * @returns {Boolean}
   */
  isArray: arg => {
    if (typeof Array.isArray === 'undefined') {
      return Object.prototype.toString.call(arg) === '[object Array]'
    }
    return Array.isArray(arg)
  },
  /**
   * @param {string} str
   * @returns {Boolean}
   */
  isString: str => {
    if (typeof str === 'string' || str instanceof String) {
      return true
    }
    return false
  }
}

export { RegExpr }
